import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { getDetailSchedule, editSchedule, deleteSchedule } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import ScheduleForm from 'components/backoffice/forms/scheduleForm';
import { addToFormData } from 'helpers';

const ScheduleEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext()

  const { t } = useTranslation(['backoffice']);


  const detailSchedule = async () => {
    try {
      const { data, status } = await getDetailSchedule(id);
      if (status === 200) {
        setSchedule(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    detailSchedule();
  }, []);

  useEffect(()=>{
    if(schedule){
      setTitle(t('edit', {title: schedule?.title}))
    }
    return () => {
      setTitle(''); 
    };
  },[schedule, setTitle])


  const onSubmit = useCallback(async (values) => {
    setLoading(true);

    const formData = new FormData();
    const items = {
      title: values.title,
      status: values.status,
      type_schedule: values.type_schedule,
      start_date: values.start_date,
      end_date: values.end_date,
      body: values.body,
      place: values.place,
      tags: values.tags,
      image: values.image
    }

    if (typeof values.image === 'string' && values.image.startsWith('http')) {
      try {
        const response = await fetch(values.image);
        const blob = await response.blob();
        const file = new File([blob], 'image.jpg', { type: blob.type });
        items.image = file;
      } catch (error) {
        console.error('Error al convertir la imagen:', error);
      }
    }

    addToFormData(formData, items)

    try {
      const { status } = await editSchedule(formData, id);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/schedules', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteSchedule(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/schedules', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  return (
    <>
      <Title text={t('editschedule')} />
      <ScheduleForm
        isEditing={true}
        onSubmitForm={onSubmit}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        defaultValues={schedule}
        onDelete={handleDelete}
        id={id}
        loading={loading}
      />
    </>
  );
};

export default ScheduleEdit;
